// This file is automatically generated by copy-versions.ts script

export const application = {version: '1.0.0-beta', revision: '', branch: ''};
export const dependencies = {nx: '11.1.5', cli: '11.1.1', core: '11.1.0', mat: '11.2.1', rxjs: '6.6.3', svgjs: '2.7.1', ts: '4.0.7', webpack: '4.44.2'};
export const date = '2025-08-04T13:01:57.014Z';
